export enum KnowledgeBaseWorkMode {
    CatalogsView,
    Search
}

export enum ArticleWorkMode {
    View,
    Edit
}
